module.exports = __webpack_public_path__ + "static/floor-801235448b42e81891b9b8f0edd07d97.jpg";